import { render, staticRenderFns } from "./NibPerJenisPerusahaan.vue?vue&type=template&id=53a6a19d&scoped=true&"
import script from "./NibPerJenisPerusahaan.vue?vue&type=script&lang=js&"
export * from "./NibPerJenisPerusahaan.vue?vue&type=script&lang=js&"
import style0 from "./NibPerJenisPerusahaan.vue?vue&type=style&index=0&id=53a6a19d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a6a19d",
  null
  
)

export default component.exports